import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {
  // Observable string sources
  private emitChangeSource = new Subject<any>();
  private auditExecuted = false;
  private tokenSource = new BehaviorSubject<any>(null); 

  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  tokenEmitted$ = this.tokenSource.asObservable();

  // Service message commands
  emitChange(change: any) {
    this.emitChangeSource.next(change);
  }
  constructor() { }
  markAuditExecuted() {
    this.auditExecuted = true;
  }

  isAuditExecuted(): boolean {
    return this.auditExecuted;
  }

  resetAuditExecuted() {
    this.auditExecuted = false;
  }

  emitToken(data: any) {
    this.tokenSource.next(data);
  }

}
